/**
 * Get value of any property of an object
 * @param {any} objectParam - The title of the book.
 */
export const getRandomValueFromObject = (objectParam: object) => {
  const values = Object.values(objectParam)
  return values[Math.floor(Math.random() * values.length)]
}
